var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { doWhenP } from '../utils';
import { parseUriQuery } from '../web';
import { getClientId } from './GoogleClientId';
import { updateRequest, getRequestId } from '../dataLayer';
import { getCacheItem, setCacheItem } from '../cache';
const CACHED_KEY = 'google_data';
function captureGclData() {
    const { gclid = null, gclsrc = null } = parseUriQuery() || {};
    return { gclid: gclid, gclsrc: gclsrc };
}
function updateGoogleData({ gclid, gclsrc }) {
    const clientId = getClientId();
    const requestId = getRequestId();
    const cachedData = getCacheItem(CACHED_KEY) || {};
    const data = {};
    if (gclid)
        data.gclid = gclid;
    if (gclsrc)
        data.gclsrc = gclsrc;
    if (clientId)
        data.client_id = clientId;
    if (requestId)
        data.request_id = requestId;
    const entries = Object.entries(data);
    const hasChanges = entries.some(([k, v]) => cachedData[k] !== v);
    /** Return if we don't have any data to send */
    if (!requestId || entries.length < 2 || !hasChanges)
        return;
    updateRequest(requestId, { [CACHED_KEY]: data }).then(() => {
        setCacheItem(CACHED_KEY, Object.assign(Object.assign({}, cachedData), data));
    });
}
export function handlePredicate() {
    return !!(getRequestId() && getClientId());
}
export function run() {
    return __awaiter(this, arguments, void 0, function* (expiration = 10000) {
        /** Capture data before user navigates away */
        const gclData = captureGclData();
        return doWhenP(handlePredicate, expiration, true)
            .then(() => updateGoogleData(gclData))
            .catch(e => {
            console.log('update google data error: ', e);
        });
    });
}
//# sourceMappingURL=googleData.js.map